/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_VerifiedInputs */

const en_fix_verified = /** @type {(inputs: Fix_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked`)
};

const de_fix_verified = /** @type {(inputs: Fix_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geprüft`)
};

/**
* | output |
* | --- |
* | "Checked" |
*
* @param {Fix_VerifiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_verified = /** @type {((inputs?: Fix_VerifiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_VerifiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_verified(inputs)
	return en_fix_verified(inputs)
});